(() => {
  const routerKey = "__brihaHistoryNav";
  const mainSelector = "#MainContent";

  if (
    (window.Shopify && window.Shopify.designMode) ||
    window.__brihaHistoryNavInstalled ||
    !document.querySelector(mainSelector)
  ) {
    return;
  }

  const cleanPath = (path) => (path.endsWith("/") ? path.slice(0, -1) : path);
  const rootPath = cleanPath(
    new URL(
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/",
      window.location.origin
    ).pathname
  );
  const cache = new Map();
  const templateType = (bodyClass) => {
    if (bodyClass.split(" ").includes("template-index")) return "home";
    if (bodyClass.split(" ").includes("template-product")) return "product";
    return null;
  };
  const isHomeUrl = (url) => cleanPath(url.pathname) === rootPath;
  const isProductUrl = (url) => url.pathname.includes("/products/");
  const currentType = templateType(document.body.className);

  if (currentType !== "home" && currentType !== "product") return;

  const makeKey = () => "briha-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8);
  const storedState = window.history.state && window.history.state[routerKey];
  let currentKey = (storedState && storedState.key) || makeKey();
  let activeType = currentType;
  let navigationPending = false;

  const getCanonical = () => document.querySelector('link[rel="canonical"]');
  const getDescription = () => document.querySelector('meta[name="description"]');
  const makeEntry = (key, type, url, main) => ({
    key,
    type,
    url,
    main,
    bodyClass: document.body.className,
    title: document.title,
    canonical: getCanonical() ? getCanonical().getAttribute("href") : "",
    description: getDescription() ? getDescription().getAttribute("content") : "",
    scrollX: window.scrollX,
    scrollY: window.scrollY,
    styleUrls: [],
  });
  const activeEntry = makeEntry(
    currentKey,
    activeType,
    window.location.href,
    document.querySelector(mainSelector)
  );
  cache.set(currentKey, activeEntry);

  const withRouterState = (state, key, type, url) => ({
    ...(state && typeof state === "object" ? state : {}),
    [routerKey]: { key, type, url },
  });
  window.history.replaceState(
    withRouterState(window.history.state, currentKey, activeType, window.location.href),
    "",
    window.location.href
  );
  window.history.scrollRestoration = "manual";
  window.__brihaHistoryNavInstalled = true;
  document.documentElement.dataset.brihaHistoryNav = makeKey();

  const saveCurrentEntry = () => {
    const entry = cache.get(currentKey);
    const main = document.querySelector(mainSelector);
    if (!entry || !main) return;
    entry.main = main;
    entry.bodyClass = document.body.className;
    entry.title = document.title;
    entry.canonical = getCanonical() ? getCanonical().getAttribute("href") : "";
    entry.description = getDescription() ? getDescription().getAttribute("content") : "";
    entry.scrollX = window.scrollX;
    entry.scrollY = window.scrollY;
    entry.url = window.location.href;
  };

  const setMetadata = (entry) => {
    document.title = entry.title;
    const canonical = getCanonical();
    if (canonical && entry.canonical) canonical.setAttribute("href", entry.canonical);
    const description = getDescription();
    if (description && entry.description) description.setAttribute("content", entry.description);
  };

  const getThemeStyles = (doc) =>
    [...doc.querySelectorAll('link[rel="stylesheet"]')]
      .map((link) => link.href)
      .filter((href) => href.includes("/cdn/shop/t/") && href.includes("/assets/"));

  const ensureStyles = async (hrefs) => {
    for (const href of hrefs) {
      const exists = [...document.querySelectorAll('link[rel="stylesheet"]')].some(
        (link) => link.href === href
      );
      if (exists) continue;
      await new Promise((resolve) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        link.dataset.brihaHistoryStyle = "true";
        link.onload = resolve;
        link.onerror = resolve;
        document.head.appendChild(link);
      });
    }
  };

  const removeInjectedStyles = () => {
    document.querySelectorAll('link[data-briha-history-style="true"]').forEach((link) => link.remove());
  };

  const loadThemeScripts = async (doc) => {
    const sources = [...doc.scripts]
      .map((script) => script.src)
      .filter((src) => {
        if (!src) return false;
        const url = new URL(src, window.location.href);
        return (
          url.origin === window.location.origin &&
          url.pathname.includes("/cdn/shop/t/") &&
          url.pathname.includes("/assets/") &&
          url.pathname.endsWith(".js")
        );
      });

    for (const src of sources) {
      const alreadyLoaded = [...document.scripts].some((script) => script.src === src);
      if (alreadyLoaded) continue;
      await new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.defer = true;
        script.onload = resolve;
        script.onerror = () => reject(new Error("Could not load theme script: " + src));
        document.head.appendChild(script);
      });
    }
  };

  const fetchPage = async (url) => {
    const response = await fetch(url.href, {
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    if (!response.ok) throw new Error("Page request failed: " + response.status);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const main = doc.querySelector(mainSelector);
    const type = templateType(doc.body.className);
    if (!main || !type) throw new Error("The requested page is not supported by the history navigator.");
    return { doc, main, type };
  };

  const announcePageView = (type) => {
    document.dispatchEvent(
      new CustomEvent("shopify:page:view", {
        detail: {
          page: {
            template: type === "home" ? "index" : "product",
            title: document.title,
            url: window.location.href,
          },
        },
      })
    );
  };

  const navigate = async (url) => {
    if (navigationPending) return;
    navigationPending = true;
    saveCurrentEntry();

    try {
      const result = await fetchPage(url);
      const styleUrls = getThemeStyles(result.doc);
      if (result.type === "product") await ensureStyles(styleUrls);
      await loadThemeScripts(result.doc);

      const nextKey = makeKey();
      const nextEntry = makeEntry(nextKey, result.type, url.href, result.main);
      nextEntry.bodyClass = result.doc.body.className;
      nextEntry.title = result.doc.title;
      const nextCanonical = result.doc.querySelector('link[rel="canonical"]');
      const nextDescription = result.doc.querySelector('meta[name="description"]');
      nextEntry.canonical = nextCanonical ? nextCanonical.getAttribute("href") : "";
      nextEntry.description = nextDescription ? nextDescription.getAttribute("content") : "";
      nextEntry.styleUrls = styleUrls;

      window.history.pushState(
        withRouterState(window.history.state, nextKey, result.type, url.href),
        "",
        url.href
      );
      const currentMain = document.querySelector(mainSelector);
      if (!currentMain) throw new Error("The current page content could not be replaced.");
      currentMain.replaceWith(result.main);
      document.body.className = nextEntry.bodyClass;
      setMetadata(nextEntry);
      cache.set(nextKey, nextEntry);
      currentKey = nextKey;
      activeType = result.type;
      if (activeType === "home") removeInjectedStyles();
      window.scrollTo(0, 0);
      announcePageView(activeType);
    } catch (error) {
      window.location.assign(url.href);
    } finally {
      navigationPending = false;
    }
  };

  document.addEventListener(
    "click",
    (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }
      const target = event.target instanceof Element ? event.target : null;
      const link = target && target.closest("a[href]");
      if (!link || link.target === "_blank" || link.hasAttribute("download") || link.dataset.noBrihaHistoryNav) return;

      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      const shouldOpenProduct = activeType === "home" && isProductUrl(url);
      const shouldReturnHome = activeType === "product" && isHomeUrl(url);
      if (!shouldOpenProduct && !shouldReturnHome) return;

      event.preventDefault();
      navigate(url);
    },
    true
  );

  window.addEventListener("popstate", (event) => {
    const routeState = event.state && event.state[routerKey];
    let entry = routeState && cache.get(routeState.key);
    const currentUrl = new URL(window.location.href);

    if (!entry && isHomeUrl(currentUrl)) {
      entry = [...cache.values()].find((cached) => cached.type === "home");
    }
    if (!entry && isProductUrl(currentUrl)) {
      entry = [...cache.values()].find((cached) => cached.type === "product" && cached.url === currentUrl.href);
    }
    if (!entry) {
      window.location.assign(window.location.href);
      return;
    }

    const currentMain = document.querySelector(mainSelector);
    if (currentMain && currentMain !== entry.main) currentMain.replaceWith(entry.main);
    document.body.className = entry.bodyClass;
    setMetadata(entry);
    if (entry.type === "home") removeInjectedStyles();
    else ensureStyles(entry.styleUrls);
    currentKey = entry.key;
    activeType = entry.type;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => window.scrollTo(entry.scrollX || 0, entry.scrollY || 0));
    });
    announcePageView(activeType);
  });
})();